import { FETCH_ISL_REWARDS } from '../actionTypes';

export const fetchIslRewards = islRewards => ({
    type: FETCH_ISL_REWARDS,
    islRewards
});